import React from 'react'

const Header = () => {
  return (
    <h2>
      Pemantau keuangan
    </h2>
  )
}

export default Header
